import { DynamicGalleryEnvService } from "@aipb/gulliver/dynamic-gallery/env";
import { CollectionContent, CollectionViewMode } from "@aipb/gulliver/dynamic-gallery/model";
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { faImages } from '@fortawesome/pro-regular-svg-icons';
import { NgxMasonryOptions } from 'ngx-masonry/lib/ngx-masonry-options';

@Component({
  selector: 'dg-collection-list',
  templateUrl: './collection-list.component.html',
  styleUrls: ['./collection-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CollectionListComponent {
  @Input() collections: CollectionContent[] = [];
  @Input() viewMode: CollectionViewMode;

  @Output() action: EventEmitter<CollectionContent> = new EventEmitter<CollectionContent>();

  recordCountIcon = faImages;

  masonryOptions: NgxMasonryOptions = {
    itemSelector: '.masonry-item',
    columnWidth: '.grid-sizer',
    horizontalOrder: true,
    percentPosition: true
  };

  defaultImage = this.dynamicGalleryEnv.env.defaultImage;

  constructor(private dynamicGalleryEnv: DynamicGalleryEnvService) {}

  isMasonry() {
    return this.viewMode === 'masonry';
  }

  isList() {
    return this.viewMode === 'list';
  }
}
